/**
 * Migration utility to clean up invalid language values in localStorage
 * This prevents the app from crashing when an unsupported language is stored
 */

export const migrateLanguageStorage = () => {
  try {
    // Check localStorage for language storage
    const storageKey = 'language-storage';
    const storedData = localStorage.getItem(storageKey);

    if (storedData) {
      const parsed = JSON.parse(storedData);
      const currentLang = parsed?.state?.currentLanguage;

      // If current language is not 'en' or 'de', reset to 'en'
      if (currentLang && currentLang !== 'en' && currentLang !== 'de') {
        console.warn(`Invalid UI language found: ${currentLang}, resetting to 'en'`);

        parsed.state.currentLanguage = 'en';
        localStorage.setItem(storageKey, JSON.stringify(parsed));

        console.log('Language storage migrated successfully');
      }
    }
  } catch (error) {
    console.error('Error migrating language storage:', error);
    // If there's any error, just clear the corrupted data
    localStorage.removeItem('language-storage');
    console.log('Language storage cleared due to corruption');
  }
};

// Run migration on import
migrateLanguageStorage();